export const authSurfaceSx = {
  borderRadius: "24px",
  background: "rgba(255, 255, 255, 0.94)",
  border: "1px solid rgba(20, 41, 62, 0.12)",
  boxShadow: "0 24px 70px rgba(2, 7, 13, 0.28)",
  overflow: "hidden",
};

export const authPanelSx = {
  borderRadius: "24px",
  background:
    "linear-gradient(145deg, rgba(8, 18, 31, 0.96), rgba(12, 35, 58, 0.92))",
  color: "#ffffff",
  border: "1px solid rgba(255, 255, 255, 0.12)",
  boxShadow: "0 22px 60px rgba(2, 7, 13, 0.28)",
  overflow: "hidden",
};

export const authInputSx = {
  "& .MuiOutlinedInput-root": {
    minHeight: 52,
    borderRadius: "15px",
    backgroundColor: "#ffffff",
    fontWeight: 700,
    "& fieldset": {
      borderColor: "rgba(20, 41, 62, 0.14)",
    },
    "&:hover fieldset": {
      borderColor: "rgba(20, 41, 62, 0.26)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "rgba(20, 41, 62, 0.34)",
      boxShadow: "0 0 0 3px rgba(20, 41, 62, 0.08)",
    },
  },
  "& .MuiInputLabel-root": {
    fontWeight: 700,
    color: "#7a8797",
    "&.Mui-focused": {
      color: "#4f5e70",
    },
  },
  "& .MuiInputBase-input": {
    fontWeight: 700,
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #ffffff inset",
      WebkitTextFillColor: "#08121f",
      caretColor: "#08121f",
      borderRadius: "15px",
    },
  },
};

export const primaryButtonSx = {
  minHeight: 44,
  borderRadius: "15px",
  fontWeight: 900,
  textTransform: "none",
  boxShadow: "0 12px 26px rgba(8, 120, 237, 0.28)",
};

export const secondaryButtonSx = {
  minHeight: 44,
  borderRadius: "15px",
  fontWeight: 900,
  textTransform: "none",
  borderColor: "rgba(20, 41, 62, 0.14)",
  color: "#08121f",
  backgroundColor: "#ffffff",
};

export const authFeatureChipSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.75,
  px: 1.35,
  py: 0.75,
  borderRadius: "999px",
  backgroundColor: "rgba(8, 120, 237, 0.12)",
  color: "#0878ed",
  fontSize: "0.78rem",
  fontWeight: 900,
};
